import React, { useState, useEffect } from 'react'
import Moment from 'react-moment'
import * as ReactBootstrap from 'react-bootstrap'
import { GSXService } from '../../../services'
import { showErrorToast } from '../../../state/toasts'
import { useDispatch } from 'react-redux'

import * as components from '../../../components'

const Log = ({
  api,
  method,
  gsx_user_name,
  gsx_ship_to,
  device_identifier,
  created_at,
}) => {
  return (
    <div>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs="12">
          <ReactBootstrap.Row>
            <ReactBootstrap.Col xs="6">
              <strong> {gsx_user_name} </strong>
              <sub>
                <Moment format="DD-MM-YYYY hh:mm A" local>
                  {created_at}
                </Moment>
                <sub>
                  {' '}
                  <strong>
                    {' '}
                    <Moment fromNow>{created_at}</Moment>
                  </strong>{' '}
                </sub>
              </sub>
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs="12">
          <p style={{ wordWrap: 'break-word' }} className="text-justify">
            {gsx_ship_to}
          </p>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </div>
  )
}

export const GSXLogTable = ({ device_identifier }) => {
  const dispatch = useDispatch()
  const [logs, setLogs] = useState([])
  useEffect(() => {
    const getDeviceInfo = () => {
      const data = { device_identifier: device_identifier }
      new GSXService()
        .logs(data)
        .then((response) => {
          setLogs(response.results)
        })
        .catch((errors) => {
          dispatch(
            showErrorToast('Could not get warranty Info ', errors.response.data)
          )
        })
    }
    getDeviceInfo()
  }, [device_identifier, dispatch])

  return (
    <div className="col">
      <ReactBootstrap.Card className="mt-5">
        <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
          Previous Log
        </ReactBootstrap.Card.Title>
        <ReactBootstrap.Card.Body>
          {logs.length ? (
            <components.ItemList
              itemRenderer={(index, key) => {
                return (
                  <div key={logs[index].url}>
                    <Log {...logs[index]} />
                  </div>
                )
              }}
              length={logs.length}
            />
          ) : (
            <ReactBootstrap.Alert variant={'info'}>
              No previous comments found.
            </ReactBootstrap.Alert>
          )}
        </ReactBootstrap.Card.Body>
      </ReactBootstrap.Card>
    </div>
  )
}
